module.exports = __webpack_public_path__ + "img/LinkedInAds.a2a4fcfd.svg";